import { useExecuteToolMutation } from '@shared/generated/graphql';

export type ExecuteToolResult = {
  toolOutput: string;
};

export function useExecuteTool() {
  const [executeToolMutation, { loading }] = useExecuteToolMutation();

  const executeTool = async (
    toolName: string,
    toolInput: object,
    organizationId: string
  ): Promise<ExecuteToolResult> => {
    const result = await executeToolMutation({
      variables: {
        input: {
          toolName,
          toolInput,
          organizationId,
        },
      },
    });

    if (!result.data?.executeTool.success) {
      throw new Error(
        result.data?.executeTool.error || 'Failed to execute tool'
      );
    }

    return {
      toolOutput: result.data.executeTool.toolOutput ?? '',
    };
  };

  return { executeTool, loading };
}
